module.exports = __webpack_public_path__ + "static/1_1_defineai_FI-80eb9565796ef8957a158070ccf6d240.svg";